module.exports = __webpack_public_path__ + "img/cb9-r-100.48a3f08d.gif";